import React, { useEffect, useState, useRef } from 'react';
export function Philosophy() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <div ref={sectionRef} className="py-32 md:py-40 overflow-hidden bg-cream-100 dark:bg-charcoal-900" data-id="element-200">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center" data-id="element-201">
        <div className={`transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-202">
          <p className="text-3xl md:text-4xl font-bold text-charcoal-500 dark:text-charcoal-200" data-id="element-203">
            Trusted by{' '}
            <span className="text-mint-500 font-bold" data-id="element-204">5,000+ users</span>
          </p>
        </div>
      </div>
    </div>;
}